
<mc-error-message
  *ngIf="error$ | async"
  [message]="error$ | async"
></mc-error-message>

<div class="sidebar" *ngIf="popularTags$ | async">
  <p>Popular Tags</p>

 <!--  <mc-loading *ngIf="isLoading$ | async"></mc-loading> -->

  <div class="tag-list">
    <a
      *ngFor="let popularTag of popularTags$ | async"
      [routerLink]="['/tags', popularTag]"
      class="tag-default tag-pill"
    >
      {{ popularTag }}
    </a>
  </div>
</div>
